module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-BlackItalic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-BlackItalic.ttf
// module id = 61
// module chunks = 8